<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">创建钱包</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">智能合约</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">REMIX</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">WEB3JS</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">TRUFFLE</a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">安全帽</a></p>
          <!-- <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">2222222</a></p> -->
          <div class="subAnchor">
            <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->
    
          </div>
        </div>
      </div>
      <div class="p1">工具</div>
      <div id="box1" class="p2">创建钱包</div>
      <div class="p4">密钥管理</div>
      <div class="p3">本文是关于 FaxChain 上去中心化应用程序客户端密钥管理策略的指南</div>
      <div class="p4">设置 Web3</div>
      <div class="p3">web3.js是一个 javascript 库，它允许我们的客户端应用程序与区块链对话。我们将 web3 配置为通过 Metamask 进行通信。</div>
      <div class="p4">连接 FaxChain 网络</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">// testnet</div>
          <div style="padding:5px 0">const web3 = new Web3('http://13.230.73.12:26659');</div>
        </div>
      </div>
      <div class="p4">设置账户</div>
      <div class="p3">如果 web3 安装实例化成功，下面应该会成功返回一个随机账号：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">const account = web3.eth.accounts.create();</div>
        </div>
      </div>
      <div class="p4">恢复账户</div>
      <div class="p3">如果您备份了您帐户的私钥，您可以使用它来恢复您的帐户。</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">const account = web3.eth.accounts.privateKeyToAccount("$private-key")</div>
        </div>
      </div>
      <div id="box2" class="p2">智能合约</div>
      <div class="p3">更多信息，请参阅<a href="https://docs.soliditylang.org/en/v0.8.13/">智能合约</a> </div>
      <div id="box3" class="p2">REMIX</div>
      <div class="p3">更多信息，请参阅<a href="https://remix.ethereum.org/">Remix</a> </div>
      <div id="box4" class="p2">WEB3JS</div>
      <div class="p3">更多信息，请参阅<a href="https://web3js.readthedocs.io/en/v1.2.11/">Web3js</a> </div>
      <div id="box5" class="p2">TRUFFLE</div>
      <div class="p3">更多信息，请参阅<a href="https://trufflesuite.com/docs/teams/quickstart">Truffle</a> </div>
      <div id="box6" class="p2">安全帽</div>
      <div class="p3">更多信息，请参阅<a href="https://hardhat.org/">安全帽</a> </div>
      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">创建钱包</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">智能合约</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">REMIX</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">WEB3JS</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">TRUFFLE</a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">安全帽</a></p>
      <!-- <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">2222222</a></p> -->
      <div class="subAnchor">
        <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->

      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Overview',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
        font-size: 15px
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>